module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-350.6108e99a.png";